import { PhoneInput, PhoneInputProps } from 'libs/ui';

import { FieldType } from '../types';
import { useField } from '../useField';

export interface PhoneFieldProps
  extends FieldType,
    Omit<PhoneInputProps, 'name' | 'onChange' | 'onChangeText' | 'value'> {}

/**
 * PhoneField.
 */
export const PhoneField = ({
  name,
  readOnly,
  allowSubmit,
  ...props
}: PhoneFieldProps) => {
  const { field, helpers, inputProps, meta } = useField<string | undefined>(
    name,
    {
      allowSubmit,
    }
  );

  return (
    <PhoneInput
      {...props}
      name={name}
      value={field.value}
      onBlur={field.onBlur(name)}
      onChange={() => {
        if (meta.isError) {
          helpers.setError(undefined);
        }
      }}
      onChangeText={(v) => {
        helpers.setValue(v);
      }}
      {...inputProps}
    />
  );
};
